import chooseAdvisorDialogController from './chooseAdvisorDialogController';

angular
  .module( 'VSPApp' )
  .controller( 'chooseAdvisorDialogController', chooseAdvisorDialogController );
